/* eslint-disable @typescript-eslint/explicit-function-return-type */
import axios from "axios";
import { DOMAIN ,DOMAIN_CJS,DOMAIN_LIVE,WECOM_URL, CommunityCollectLink} from "./Config";
import { Toast } from "antd-mobile";
const CancelToken = axios.CancelToken;
const request = async (uri, { method = "POST", data, header = {}, excludeQueryParams = [] },flag=1) => {
  const search=new URLSearchParams(window.location.search);
  let DOMAINLAST=DOMAIN;
  if(flag==2){
    DOMAINLAST=DOMAIN_CJS;
  }else if(flag==3){
    DOMAINLAST=DOMAIN_LIVE;
  }else if(flag==4){
    DOMAINLAST=WECOM_URL;
  }else if(flag==4){
    DOMAINLAST=WECOM_URL;
  }else if (flag==5) {
    DOMAINLAST = CommunityCollectLink
  }
  const headers={
    "Content-Type": "application/json",
    ...header,
  };
  if(flag==1||flag==2){
    headers["gh_id"]=search.get("gh_id");
  }
  if(window.cancleList[uri]){
    window.cancleList[`${uri}`]();
    await new Promise((resolve, reject) => {
      setTimeout(() =>{
        resolve(1)
      },5)
    })
  }
  const queryParams = new URL(window.location.href).searchParams;
  excludeQueryParams.forEach(key => queryParams.delete(key));
  const moredata = queryParams.toString();
  uri += uri.indexOf("?") > 0 ? `&${moredata}` : `?${moredata}`;
  const requestOptions = {
    url: DOMAINLAST + uri,
    method,
    headers,
    withCredentials: flag!=4,
    cancelToken: new CancelToken(c => {
      // 调用c就可以取消此请求
      window.cancleList[uri]=c;
    }),
    validateStatus: (status) => status >= 200 && status <= 401,
  };
  if (method === "POST") {
    requestOptions.data = JSON.stringify(data);
  }
  return axios(requestOptions)
    .then(({ data}) => {
      delete window.cancleList[uri];
      if (data.result === "success") {
        return { data };
      } 
        if (data.result === "redirect") {
          window.location.href = data.data;
          return;
        }
        if (data.result === "autherror") {
          return;
        }
        Toast.show(data.message || "请求失败，请重试!");
        return { err: data.message };
      
    })
    .catch((err) =>{
      delete window.cancleList[uri];
      return { err }
    });
};

export default request;

const uploadImg = async (file) => {

  const baseUrl = `https://mlj36.oss-cn-shenzhen.aliyuncs.com`;

  const fileName = `${new Date().getTime()  }_${  file.name}`;
  const path = `d11/${fileName}`;

  const { data, err } = await axios({
    url: `${DOMAIN  }/common/policyOss?dir=d11`,
  })
    .then(({ data, status }) => {
      if (status === 200) {
        return { data: data.data };
      }
      return { err: data };
    })
    .catch((err) => ({ err }));
  if (err) {
    Toast.show("上传失败，请重试");
    return;
  }
  const formData = new FormData();
  formData.append("OSSAccessKeyId", data.accessid);
  formData.append("policy", data.policy);
  formData.append("signature", data.signature);
  formData.append("key", path);
  formData.append("expire", data.expire);
  formData.append("success_action_status", 200);
  formData.append("file", file);

  const options = {
    url: baseUrl,
    method: "POST",
    withCredentials: false,
    data: formData,
    validateStatus: (status) => status >= 200 && status <= 401,
  };
  return axios(options)
    .then(({ data, status }) => {
      if (status === 200) {
        return { data: `${baseUrl  }/${  path}` };
      }
      Toast.show(data.message || "请求失败，请重试!",3000);
      return { err: "上传失败" };
    })
    .catch((err) => ({ err }));

  // const formData = new FormData();
  // formData.append("file", file);

  // const options = {
  //   url: DOMAIN + `/common/upload`,
  //   method: "POST",
  //   withCredentials: true,
  //   data: formData,
  //   validateStatus: (status) => status >= 200 && status <= 401,
  // };
  // return axios(options)
  //   .then(({ data, status }) => {
  //     if (data.result === "success") {
  //       return { data: data.data };
  //     }
  //     Toast.show(data.message || "请求失败，请重试!");
  //     return { err: "上传失败" };
  //   })
  //   .catch((err) => ({ err }));
};

export { uploadImg };
